<template>
  <div>
    <b-card class="mb-2" no-body>
      <b-card-header>Placemark</b-card-header>
      <b-container fluid>
        <b-row class="mt-3 mb-2">
          <b-col sm="3">
            <label class="mt-2" for="titleBox">Title</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="titleBox" v-model="placemarkData.title"></b-form-input>
            <!-- <b-form-input id="titleBox" type="string" v-model="placemarkData.title"></b-form-input> -->
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-2">
          <b-col sm="3">
            <label class="mt-2" for="descBox">Description</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea
              id="descBox"
              v-model="placemarkData.description"
              placeholder="Enter description..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-2">
          <b-col sm="3">
            <label class="mt-2" for="longBox">Longitude</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="longBox" type="number" v-model="placemarkData.longitude"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-2">
          <b-col sm="3">
            <label class="mt-2" for="latBox">Latitude</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="latBox" type="number" v-model="placemarkData.latitude"></b-form-input>
          </b-col>
        </b-row>

      </b-container>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    placemarkData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>

</style>